import React, { useContext } from 'react';
import { putPropsToEventHandlers } from '../helpers/node';
import PlugInIcon from '../../../resources/plugIn.svg';
import { useBaseStyles } from './BlockNode/style';
import { SchemaDisplayContext } from '../context';

function ConnectionSocketIn(props) {
  const { connectionPort } = useBaseStyles();
  const { className = '', alt = '' } = props;
  const { node: { connectionSocketIn: { eventHandlers } } } = useContext(SchemaDisplayContext);

  return (
    <img
      alt={alt}
      draggable={false}
      className={`${connectionPort} ${className}`}
      src={PlugInIcon}
      {...putPropsToEventHandlers(eventHandlers, props)}
    />
  );
}

export default ConnectionSocketIn;
